export default function isSubscriptionResult(result) {
	const {data} = result;
	return data?.GlideRecord_Subscription;
}
